import RibbonButton, { RibbonButtonState } from './RibbonButton';
import strings from 'owa-strings/owa-mail-strings';
import { toggleStrikethrough } from 'roosterjs-editor-api';

const strikethrough: RibbonButton = {
    key: 'strikethrough',
    title: () => strings.strikethrough,
    imageSrc: require('../svg/strikethrough.svg'),
    buttonState: formatState =>
        formatState.isStrikeThrough ? RibbonButtonState.Checked : RibbonButtonState.Normal,
    onExecute: plugin => toggleStrikethrough(plugin.getEditor()),
};

export default strikethrough;
